import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';

@Component({
    selector: 'kaz-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent]
})
export class PrivacyComponent {

}
